import type { FinishingPart, FinishingMethod, ColorOption } from '@/mocks/finishingTree';

export interface ConfirmedSelection {
  id: string;
  partId: string;
  partCode: string;
  partName: string;
  engName?: string;
  methodId: string;
  methodCode: string;
  methodName: string;
  methodDescription?: string;
  colorHex: string;
  colorName: string;
  /** Quotation identity metadata. Only finish_l1 | print selections are priced. */
  sourceType?: 'finish_l1' | 'print';
}

let selectionCounter = 0;
export function nextSelectionId(): string {
  selectionCounter += 1;
  return `sel-${selectionCounter}`;
}

export const PART_ICONS: Record<string, string> = {
  'part-cap': 'ri-capsule-line',
  'part-body': 'ri-contrast-drop-2-line',
  'part-pump': 'ri-contrast-drop-line',
  'part-base': 'ri-layout-bottom-2-line',
};

export interface ProductSummary {
  id: string;
  name: string;
  sku: string;
  imageUrl: string;
  material: string;
  capacity: string;
  moq: number;
  moqUnit: string;
}

export type {
  FinishingPart,
  FinishingMethod,
  ColorOption,
};